import { h } from 'vue'

export const MicrosoftIcon = {
	render() {
		return h('svg', { viewBox: '0 0 24 24', width: 20, height: 20 }, [
			h('path', { fill: '#f35325', d: 'M1 1h10v10H1z' }),
			h('path', { fill: '#81bc06', d: 'M12 1h10v10H12z' }),
			h('path', { fill: '#05a6f0', d: 'M1 12h10v10H1z' }),
			h('path', { fill: '#ffba08', d: 'M12 12h10v10H12z' })
		])
	}
}

export const KeycloakIcon = {
	render() {
		return h('svg', { viewBox: '0 0 24 24', width: 20, height: 20 }, [
			h('path', { fill: '#4d4d4d', d: 'M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.18l7.5 3.75v7.5L12 19.18l-7.5-3.75v-7.5L12 4.18z' }),
			h('path', { fill: '#4d4d4d', d: 'M12 8a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4z' })
		])
	}
}

export const DefaultIcon = {
	render() {
		return h('svg', { viewBox: '0 0 24 24', width: 20, height: 20 }, [
			h('path', { fill: '#6c757d', d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
		])
	}
}
